import React from "react";
import { twMerge } from "tailwind-merge";

export const SectionCard: React.FC<{
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}> = ({ title, icon, children, className = "" }) => (
  <div
    className={twMerge(
      "bg-white rounded-xl border border-gray-200/60 overflow-hidden shadow-sm",
      className,
    )}
  >
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
      <span className="text-[10px] font-semibold uppercase tracking-widest text-gray-400">
        {title}
      </span>
      {icon && <span className="text-gray-300">{icon}</span>}
    </div>
    <div className="p-4">{children}</div>
  </div>
);
